import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { SystemNames } from './system-names.model';

export const loadSystemNamess = createAction(
  '[SystemNames/API] Load SystemNamess',
  props<{ systemNamess: SystemNames[] }>()
);

export const addSystemNames = createAction(
  '[SystemNames/API] Add SystemNames',
  props<{ systemNames: SystemNames }>()
);

export const upsertSystemNames = createAction(
  '[SystemNames/API] Upsert SystemNames',
  props<{ systemNames: SystemNames }>()
);

export const addSystemNamess = createAction(
  '[SystemNames/API] Add SystemNamess',
  props<{ systemNamess: SystemNames[] }>()
);

export const upsertSystemNamess = createAction(
  '[SystemNames/API] Upsert SystemNamess',
  props<{ systemNamess: SystemNames[] }>()
);

export const updateSystemNames = createAction(
  '[SystemNames/API] Update SystemNames',
  props<{ systemNames: Update<SystemNames> }>()
);

export const updateSystemNamess = createAction(
  '[SystemNames/API] Update SystemNamess',
  props<{ systemNamess: Update<SystemNames>[] }>()
);

export const deleteSystemNames = createAction(
  '[SystemNames/API] Delete SystemNames',
  props<{ id: string }>()
);

export const deleteSystemNamess = createAction(
  '[SystemNames/API] Delete SystemNamess',
  props<{ ids: string[] }>()
);

export const clearSystemNamess = createAction(
  '[SystemNames/API] Clear SystemNamess'
);

export const createInstitutionSystemNamess = createAction(
  '[SystemNames/API] Create Institution SystemNamess',
  props<{
    input?:any
  }>()
);

export const updateInstitutionSystemNamess = createAction(
  '[SystemNames/API] Update Institution SystemNamess',
  props<{
    input?:any
  }>()
);

export const getAllInstitutionSystemNamess = createAction(
  '[SystemNames/API] Get All Institution SystemNamess',
  props<{
    filtering: any
  }>()
);

export const deleteInstitutionSystemNamess = createAction(
  '[SystemNames/API] Delete Institution SystemNamess',
  props<{
    systemUniqueId?: string,
    id: string
  }>()
);
